<template>
  <div>
    <MfaPopup @authenticated="fetchDatas"></MfaPopup>
    <h1>Liste du matériel informatique</h1>
    <button class="btn btn-dark" @click="edit(0)">Nouveau matériel</button>
    <div style="display: inline-block;">
      <vue-good-table class="materiel-table"
                      :columns="columns"
                      :rows="materielList"
                      styleClass="vgt-table striped"
                      :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }"
                      :sort-options="{
                                        enabled: true,
                                        multipleColumns: true,
                                      }">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'edit'" class="edit" @click="edit(props.row.MaterielId)">
            <font-awesome-icon icon="edit" />
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </div>
    <hr />
    <h1>Export liste matériel</h1>
    <select class="form-select" v-model="exportSelectedUser">
      <option value="0">Export global</option>
      <option v-for="user in users" :key="user.UserId" :value="user.UserSdcGuid">{{ user.Label }}</option>
    </select>
    <br />
    <button class="btn btn-dark" v-on:click="exportDatas()">Exporter</button>


    <!-- MODAL -->

    <Modal :open="modalOpen" :title="modalValues.title" @close="modalOpen = false" class="xl-modal">
      <form v-on:submit.prevent="save">
        <div class="row">
          <div v-for="(attr, index) in modalValues.attributes" class="col-4" :key="index">
            <label class="form-label" v-if="attr[0] != 'UserGuid'">{{ attr[0] }}</label>
            <!-- Si le champ n'est pas l'id, on affiche en éditable -->
            <input type="text" v-model="attr[1]" class="form-control" v-if="attr[0] != 'MaterielId' && attr[0] != 'Utilisateur' && attr[0] != 'UserGuid'" name="values[]" :disabled="attr[0] == 'MaterielName' && modalValues.attributes[0][1] != 0" />
            <!-- Sinon, on le désactive -->
            <input type="text" v-model="attr[1]" class="form-control" v-if="attr[0] == 'MaterielId'" name="values[]" disabled />
            <!-- Cas spécial du sélecteur d'utilisateurs -->
            <select class="form-select" v-if="attr[0] == 'Utilisateur'" name="values[]" v-model="modalValues.selectedUser">
              <option value="0">-- Supprimer l'utilisateur</option>
              <option v-for="user in users" :key="user.UserId" :value="user.UserSdcGuid">{{ user.Label }}</option>
            </select>
            <br />
          </div>
          <div class="col-12">
            <button class="btn btn-dark mx-1" v-on:click="generateExcelFicheMateriel()">Générer la fiche materiel</button>
            <button class="btn btn-dark" type="submit">Sauvegarder</button>
          </div>
        </div>
      </form>
    </Modal>

  </div>
</template>

<script>

  import { getMaterielList, getMaterielCaracteristique, resetCaracteristiquesForMateriel, createMateriel, createCaracteristiquesForMateriel } from "@/utils/materielinformatique";
  import { getAllUsers } from "@/utils/cdm";
  import { Pivot } from "@/utils/pivot";
  import Modal from "@/components/Modal";
  import MfaPopup from "@/components/MfaPopup";
  import { saveWb, exportExcel } from "@/utils/exportExcel";

  // Générer un Excel
  import ExcelJS from "exceljs";

  export default {
    name: "MaterielInformatiqueListe",
    components: { Modal, MfaPopup },
    data() {
      return {
        headers: [],
        materielList: [],
        materielFullList: [],
        materielCaracteristique: [],
        users: [],
        modalOpen: false,
        modalValues: {
          currentId: 0,
          title: "",
          attributes: [],
          selectedUser: "",
        },
        exportSelectedUser: "",
      }
    },
    mounted() {
      //this.fetchDatas();
    },
    methods: {
      // Génération de la fiche materiel
      generateExcelFicheMateriel() {
        fetch("/static/Fiche_Materiel_Info.xlsx")
          .then((res) => res.blob())
          .then((data) => {
            const workbook = new ExcelJS.Workbook();
            workbook.xlsx.load(data)
             .then((wb) => {
                const worksheet = wb.worksheets[0];
                this.fillWsFicheMateriel(worksheet);
                saveWb(wb, "Fiche_Materiel_Info");
            });
          })
      },
      // Remplis l'excel avec les données récupérées
      fillWsFicheMateriel(ws) {
        ws.getCell("C2").value = this.modalValues.attributes[19][1]; // Identifiant
        ws.getCell("C3").value = this.modalValues.attributes[15][1]; // Mot de passe
        ws.getCell("B6").value = this.modalValues.attributes[2][1]; // Type materiel
        ws.getCell("C6").value = this.modalValues.attributes[3][1]; // Numéro de série
        ws.getCell("D6").value = this.modalValues.attributes[12][1]; // Marque de l'appareil
        ws.getCell("B8").value = this.modalValues.attributes[13][1]; // Modèle de l'appareil
        ws.getCell("C8").value = this.modalValues.attributes[11][1]; // Date d'attribution
        ws.getCell("D8").value = this.modalValues.attributes[21][1]; // Utilisateur
      },
      // Récupère toutes les données
      fetchDatas() {
        // On récupère la liste des utilisateurs
        getAllUsers().then(res => {
          this.users = res
            .filter(r => r.CodeThirdParty == "CMEM0")
            .map(u => {
              if (!u) return { Label: "Non Affecté", UserName: "Non Affecté", UserFirstname: "Non Affecté" };
              u.Label = u.UserName + " " + u.UserFirstname + " - " + u.Login;
              return u;
            })
            .sort((a, b) => (a.UserName > b.UserName) ? 1 : ((b.UserName > a.UserName) ? -1 : 0));

          // On récupère la liste du matériel
          getMaterielList().then(res => {
            this.materielList = Pivot(
              res.filter(e => e.RecapDisplay === true),
              "CaracteristiqueName",
              ["MaterielId", "MaterielName"],
              "MaterielId",
              "MaterielCaracteristiqueValue");

            this.materielFullList = Pivot(
              res,
              "CaracteristiqueName",
              ["MaterielId", "MaterielName"],
              "MaterielId",
              "MaterielCaracteristiqueValue");

            // On lie le matériel à un utilisateur
            this.materielList.forEach(m => {
              let usr = this.users.find(u => u.UserSdcGuid == m["GUID de l'utilisateur possédant le matériel"]);
              if (!usr) usr = { Label: "Non Affecté", UserName: "Non Affecté", UserFirstname: "Non Affecté" }
              m["Utilisateur"] = usr.UserName + " " + usr.UserFirstname;
              //m["UserGuid"] = m["GUID de l'utilisateur possédant le matériel"];
              delete m["GUID de l'utilisateur possédant le matériel"];
            });

            // On lie le matériel à un utilisateur
            this.materielFullList.forEach(m => {
              let usr = this.users.find(u => u.UserSdcGuid == m["GUID de l'utilisateur possédant le matériel"]);
              if (!usr) usr = { Label: "Non Affecté", UserName: "Non Affecté", UserFirstname: "Non Affecté" }
              m["Utilisateur"] = usr.UserName + " " + usr.UserFirstname;
              m["UserGuid"] = m["GUID de l'utilisateur possédant le matériel"];
              delete m["GUID de l'utilisateur possédant le matériel"];
            });


            // On crée la liste des entêtes
            if (this.materielList.length > 0) {
              this.headers = [];
              Object.keys(this.materielList[0]).forEach(m => {
                if (m == "MaterielId") {
                  this.headers.push("Id Matériel");
                }
                else if (m == "MaterielName") {
                  this.headers.push("Nom");
                }
                else {
                  this.headers.push(m);
                }
              });
            }
          });
        });

        // On récupère les caractéristiques possibles
        getMaterielCaracteristique().then(res => {
          this.materielCaracteristique = res;
        })
      },

      // On modifie les attributs
      edit(materielId) {
        if (materielId == 0) {
          // Création d'un matériel
          this.modalValues.title = "Création de matériel";
          this.modalValues.currentId = 0;

          // On duplique le premier materiel pour le vider et créer un formulaire vide
          var m = { ...this.materielFullList[0] };
          for (const prop of Object.getOwnPropertyNames(m)) {
            if (prop == "MaterielId") {
              m[prop] = 0;
            }
            else {
              m[prop] = "";
            }
          }

          // On transforme l'objet en tableau
          this.modalValues.attributes = Object.entries(m);

        }
        else {
          // On récupère le détail du matériel
          var m = this.materielFullList.find(e => e.MaterielId == materielId);

          this.modalValues.title = "Détail du matériel : " + m.MaterielName;
          this.modalValues.currentId = m.MaterielId;

          // On transforme l'objet en tableau
          this.modalValues.attributes = Object.entries(m);

          // On passe l'utilisateur affecté
          this.modalValues.selectedUser = m["UserGuid"];

        }
        this.modalOpen = true;
      },

      // Sauvegarde des modifications
      save(submitEvent) {
        // On vérifie que l'ID du matériel affiché soit bien celui du modal
        if (this.modalValues.currentId == submitEvent.target.elements[0].value) {

          var obj = {};

          // Création
          if (submitEvent.target.elements[0].value == 0) {
            // On duplique le premier materiel pour le vider et créer un formulaire vide
            obj = { ...this.materielFullList[0] };
            delete obj['UserGuid'];

            for (const prop of Object.getOwnPropertyNames(obj)) {
              if (prop == "MaterielId") {
                obj[prop] = 0;
              }
              else {
                obj[prop] = "";
              }
            }
          }
          // Modification
          else {
            obj = this.materielFullList.find(e => e.MaterielId == this.modalValues.currentId);
          }

          // On transforme l'objet en tableau de key/value
          var m = Object.entries(obj).map(([key, value]) => ({ key, value }));
          console.log(obj);
          console.log(m);

          // On ne modifie pas l'ID en position 0 :)
          for (var i = 1; i < submitEvent.target.elements.length - 2; i++) {
            console.log(m[i]);
            m[i].value = submitEvent.target.elements[i].value;
          }

          // On vient transformer notre liste en objet à sauvegarder en base
          var returnList = [];

          var mId = m.find(el => el.key == "MaterielId").value;
          var mName = m.find(el => el.key == "MaterielName").value;

          m.forEach(e => {
            if (e.key != "MaterielId" && e.key != "MaterielName" && e.key != "Utilisateur" && e.key != "UserGuid") {
              var ml = {
                MaterielId: mId,
                MaterielName: mName,
                CaracteristiqueCode: this.materielCaracteristique.find(mc => mc.Name == e.key).Code,
                CaracteristiqueName: e.key,
                MaterielCaracteristiqueValue: e.value
              };

              returnList.push(ml);
            }
            else if (e.key == "Utilisateur") {
              var ml = {
                MaterielId: mId,
                MaterielName: mName,
                CaracteristiqueCode: this.materielCaracteristique.find(mc => mc.Name == "GUID de l'utilisateur possédant le matériel").Code,
                CaracteristiqueName: "GUID de l'utilisateur possédant le matériel",
                MaterielCaracteristiqueValue: e.value
              };

              returnList.push(ml);
            }
          });

          // Création
          if (submitEvent.target.elements[0].value == 0) {
            createMateriel(returnList[0].MaterielName)
              .then(idMat => {
                let pList = [];
                returnList.forEach(caract => {
                  let promise = createCaracteristiquesForMateriel(idMat, caract.CaracteristiqueCode, caract.MaterielCaracteristiqueValue)
                  pList.push(promise)
                })

                Promise.all(pList).then(() => {
                  this.fetchDatas();
                })
              })
          }
          // Modification
          else {
            resetCaracteristiquesForMateriel(returnList[0].MaterielId).then(() => {
              let pList = []
              returnList.forEach(caract => {
                let promise = createCaracteristiquesForMateriel(caract.MaterielId, caract.CaracteristiqueCode, caract.MaterielCaracteristiqueValue)
                pList.push(promise)
              })

              Promise.all(pList).then(() => {
                this.fetchDatas();
              })
            })
          }

          // Fermeture du modal
          this.modalOpen = false;
        }
      },

      // Export des données
      exportDatas() {
        var res = [];

        if (this.exportSelectedUser == 0) {
          res = this.materielFullList;
        }
        else {
          res = this.materielFullList.filter(e => e.UserGuid == this.exportSelectedUser);
        }

        // On crée le fichier Excel
        var materielColumns = Object.keys(res[0]).map(m => {
          return {
            label: m,
            field: m
          }
        });
        exportExcel(materielColumns, res, 'Matériel Informatique');
      }
    },
    computed: {
      columns() {
        let res = this.headers.filter(header => header !== "Id Matériel").map(header => (
          {
            label: header,
            field: header == "Nom" ? "MaterielName" : header,
            filterOptions: { enabled: true, }
          }
        ))
        res.push({ label: "Editer", field: "edit" })
        return res;
      }
    }
  }
</script>
<style scoped>


  .edit svg {
    color: #A7C13C;
  }

  .edit:hover > svg {
    cursor: pointer;
  }

  button {
    float: right;
    margin-bottom: 5px;
  }

  table > thead {
    background: rgb(33, 37, 41);
    color: #FFFFFF;
  }

  table tr {
    border-top: none !important;
  }

  table td {
    text-align: center;
    vertical-align: middle;
  }
</style>

<style>
  .materiel-table table > thead th {
    background: rgb(33, 37, 41);
    color: #FFFFFF;
    text-align: center;
    vertical-align: middle;
    border: none !important;
    font-weight: normal;
  }
  .materiel-table table > thead tr:first-child {
    border-bottom: 1px solid #666;
  }

  .materiel-table table tr {
    border-top: none !important;
  }

  .materiel-table table td {
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin/MaterielInformatiqueListe.vue